export default __webpack_public_path__ + "static/proxima-nova-500-i-d37fa9a28de02fb329280299fe06acd7.woff2";